import React from 'react';
import { DateTime } from '@components/Shared/DateTime';
import { Body, Heading } from '@edreamsodigeo/prisma-design-system';
import { useSite } from '@edreamsodigeo/frontend-core';

interface SegmentTimeProps {
  date: string;
}

const SegmentTime: React.FC<SegmentTimeProps> = ({ date }) => {
  const site = useSite();

  return site === 'US' ? (
    <Heading color="neutral.90" type={'6'} weight="medium">
      <Body
        type="base"
        sx={{
          display: 'inline',
        }}
      >
        <DateTime value={date} type="time" pattern="short" format={'h:mm'} />
      </Body>
      <Body
        type="xxSmall"
        sx={{
          display: 'inline',
        }}
      >
        <DateTime value={date} type="time" pattern="short" format={'aa'} />
      </Body>
    </Heading>
  ) : (
    <Heading color="neutral.90" type="4" weight="medium">
      <DateTime value={date} type="time" pattern="short" />
    </Heading>
  );
};

export default SegmentTime;
